import React from 'react';
import { Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import './styles/globals.css';

// Import pages
import Home from './pages/Home';
import Methodology from './pages/Methodology';
import Correction from './pages/Correction';

// Import components
import Navbar from './components/Navbar';
import { DataProvider } from './context/DataContext';

const AppContainer = styled.div`
  min-height: 100vh;
  background-color: var(--bg-page);
`;

function App() {
  return (
    <DataProvider>
      <AppContainer>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/methodology" element={<Methodology />} />
          <Route path="/correction" element={<Correction />} />
        </Routes>
      </AppContainer>
    </DataProvider>
  );
}

export default App; 